import { observer } from 'mobx-react-lite';
import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import type { CodingAgentState } from '@/features/electron-api/features/CodingAgentsAPI';

import { codingAgentsStore as store } from './coding-agents.store';

const copyCommand = async (command: string) => {
  try {
    await navigator.clipboard.writeText(command);
    toast.success('Command copied. Paste it into Terminal to install.');
  } catch {
    toast.error('Could not copy the command');
  }
};

/** The setup step a row offers: install, sign in, or a way out of the one under way */
export const AgentActions = observer(
  ({ agent }: { agent: CodingAgentState }) => {
    const { id } = agent;
    const progress = store.activities.get(id);
    if (progress) {
      return (
        <>
          {progress.activity === 'signing-in' && agent.canReopenSignIn ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => void store.reopenSignIn(id)}
            >
              Open sign-in page
            </Button>
          ) : null}
          <Button
            variant="outline"
            size="sm"
            onClick={() => store.cancelSetup(id)}
          >
            Cancel
          </Button>
        </>
      );
    }
    if (agent.setup === 'signed-out') {
      return (
        <Button
          variant="outline"
          size="sm"
          onClick={() => void store.signIn(id)}
        >
          Sign in
        </Button>
      );
    }
    if (agent.setup !== 'not-installed') return null;
    const command = store.installCommands.get(id);
    return (
      <>
        {command ? (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => void copyCommand(command)}
          >
            Copy install command
          </Button>
        ) : null}
        <Button
          variant="outline"
          size="sm"
          onClick={() => void store.install(id)}
        >
          {command ? 'Try again' : 'Install'}
        </Button>
      </>
    );
  }
);
